(() => {
  const SECTION_ID = 'bm-fitment-options';
  const RETURN_KEY = 'bm_vehicle_return_url';
  const IMAGE_CACHE_KEY = 'bm_generation_image_cache_v1';
  const qs = (root, selector) => root?.querySelector(selector) || null;
  const qsa = (root, selector) => [...(root?.querySelectorAll(selector) || [])];

  const readImageCache = () => {
    try { return JSON.parse(window.localStorage.getItem(IMAGE_CACHE_KEY) || '{}') || {}; }
    catch (error) { return {}; }
  };

  const writeImageCache = (generationId, imageUrl) => {
    if (!generationId || !imageUrl) return;
    try {
      const cache = readImageCache();
      cache[String(generationId)] = imageUrl;
      const keys = Object.keys(cache);
      if (keys.length > 24) keys.slice(0, keys.length - 24).forEach((key) => delete cache[key]);
      window.localStorage.setItem(IMAGE_CACHE_KEY, JSON.stringify(cache));
    } catch (error) {}
  };

  const init = () => {
    const host = document.querySelector('[data-bm-vehicle-dialog]');
    if (!host || host.dataset.bmVehicleDialogReady === 'true') return;
    host.dataset.bmVehicleDialogReady = 'true';

    const panel = qs(host, '.bm-vehicle-dialog__panel');
    const stages = qsa(host, '[data-bm-dialog-stage]');
    const back = qs(host, '[data-bm-dialog-back]');
    const step = qs(host, '[data-bm-dialog-step]');
    const title = qs(host, '[data-bm-dialog-title]');
    const searchWrap = qs(host, '[data-bm-dialog-search-wrap]');
    const search = qs(host, '[data-bm-dialog-search]');
    const status = qs(host, '[data-bm-dialog-status]');
    const current = qs(host, '[data-bm-vehicle-dialog-current]');
    const currentLabel = qs(host, '[data-bm-vehicle-dialog-current-label]');
    const currentImage = qs(host, '[data-bm-vehicle-dialog-current-image]');
    const currentFallback = qs(host, '[data-bm-vehicle-dialog-current-fallback]');
    const progress = qsa(host, '[data-bm-dialog-progress]');
    const state = { brand:null, model:null, generation:null, stage:'brand' };
    let opener = null;
    let previousVehicle = null;
    let selectionMade = false;
    let imageRequestId = '';

    const api = () => window.BandenmeestersVehicle;
    const vehicleLabel = (vehicle) => api()?.vehicleLabel?.(vehicle) || [vehicle?.brand?.name,vehicle?.model?.name,vehicle?.generation?.name].filter(Boolean).join(' ');
    const nodeData = (choice) => ({ id:choice?.dataset.id || '', name:choice?.dataset.name || '', url:choice?.dataset.url || '', image:choice?.dataset.image || '' });
    const clearLegacyReturn = () => { try { sessionStorage.removeItem(RETURN_KEY); } catch(error){} };

    const setCurrentImage = (vehicle, imageUrl = '') => {
      const hasImage = Boolean(vehicle?.generation?.id && imageUrl);
      if (currentImage) {
        if (hasImage) {
          currentImage.src = imageUrl;
          currentImage.alt = vehicleLabel(vehicle);
          currentImage.hidden = false;
        } else {
          currentImage.removeAttribute('src');
          currentImage.alt = '';
          currentImage.hidden = true;
        }
      }
      if (currentFallback) currentFallback.hidden = hasImage;
    };

    const resolveCurrentImage = async (vehicle) => {
      if (!vehicle?.generation?.id || !vehicle?.generation?.url) return;
      const generationId = String(vehicle.generation.id);
      imageRequestId = generationId;
      try {
        const target = new URL(vehicle.generation.url, window.location.origin);
        let imageUrl = '';
        if (target.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '')) {
          const local = document.querySelector('.bm-vehicle-hero__visual img, .bm-generation-image img');
          imageUrl = local?.currentSrc || local?.getAttribute('src') || '';
        }
        if (!imageUrl) {
          const response = await fetch(target.toString(), { credentials:'same-origin', headers:{'X-Requested-With':'XMLHttpRequest'} });
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = doc.querySelector('.bm-vehicle-hero__visual img, .bm-generation-image img');
          imageUrl = source?.currentSrc || source?.getAttribute('src') || '';
        }
        if (!imageUrl) return;
        writeImageCache(generationId, imageUrl);
        const active = api()?.getActive?.() || previousVehicle;
        if (imageRequestId === generationId && String(active?.generation?.id || '') === generationId) setCurrentImage(active, imageUrl);
      } catch (error) {}
    };

    const closeMobileMenu = () => {
      const toggle = document.querySelector('[data-bm-mobile-menu-toggle][aria-expanded="true"]');
      if (toggle) toggle.click();
    };

    const renderCurrent = () => {
      const active = api()?.getActive?.() || previousVehicle;
      if (!current || !currentLabel) return;
      current.hidden = !active;
      if (!active) {
        setCurrentImage(null, '');
        return;
      }
      currentLabel.textContent = vehicleLabel(active);
      const cached = active?.generation?.image || readImageCache()[String(active?.generation?.id || '')] || '';
      setCurrentImage(active, cached);
      if (!cached) resolveCurrentImage(active);
    };

    const setStage = (name) => {
      state.stage = name;
      const index = {brand:0,model:1,generation:2}[name] ?? 0;
      stages.forEach((stage) => {
        const active = stage.dataset.bmDialogStage === name;
        stage.hidden = !active;
        stage.classList.toggle('is-active', active);
      });
      progress.forEach((item,i) => {
        item.classList.toggle('is-active',i === index);
        item.classList.toggle('is-done',i < index);
      });
      if (back) back.hidden = name === 'brand';
      if (searchWrap) searchWrap.hidden = name === 'brand';
      if (search) {
        search.value = '';
        search.placeholder = name === 'model' ? 'Zoek model...' : 'Zoek generatie...';
      }
      if (step) step.textContent = `Stap ${index + 1} van 3`;
      if (title) title.textContent = name === 'brand' ? 'Kies je merk' : name === 'model' ? `Kies je ${state.brand?.name || ''}-model` : 'Kies je generatie';
      const body = qs(host,'[data-bm-dialog-body]');
      if (body) body.scrollTop = 0;
    };

    const reset = () => {
      state.brand=null; state.model=null; state.generation=null;
      qsa(host,'[data-bm-dialog-options]').forEach((el)=>{el.innerHTML='';});
      if (search) search.value='';
      setStage('brand');
      if (status) status.textContent='Kies eerst je automerk';
    };

    const sort = (container,type) => {
      const choices=qsa(container,`.bm-choice[data-choice="${type}"]`);
      choices.sort((a,b)=>(a.dataset.name||'').localeCompare(b.dataset.name||'','nl',{numeric:true,sensitivity:'base'}));
      choices.forEach((choice)=>container.appendChild(choice));
    };

    const load = async (url,type) => {
      const container=qs(host,`[data-bm-dialog-options="${type}"]`);
      if(!container||!url)return false;
      container.innerHTML='<div class="bm-vehicle-dialog__loading">Laden...</div>';
      try{
        const endpoint=new URL(url,location.origin);
        endpoint.searchParams.set('section_id',SECTION_ID);
        const response=await fetch(endpoint.toString(),{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}});
        if(!response.ok)throw new Error(`HTTP ${response.status}`);
        const html=await response.text();
        const doc=new DOMParser().parseFromString(html,'text/html');
        const source=doc.querySelector(`[data-bm-options="${type}"]`);
        if(!source)throw new Error(`${type} opties niet gevonden`);
        container.innerHTML=source.innerHTML;
        sort(container,type);
        const found=Boolean(qs(container,`.bm-choice[data-choice="${type}"]`));
        if(!found)container.innerHTML=`<div class="bm-vehicle-dialog__empty">Geen ${type==='model'?'modellen':'generaties'} gevonden.</div>`;
        return found;
      }catch(error){
        console.error('Bandenmeesters voertuigassistent:',error);
        container.innerHTML='<div class="bm-vehicle-dialog__empty">Kon de voertuiggegevens niet laden. Probeer opnieuw.</div>';
        return false;
      }
    };

    const open = (trigger) => {
      opener=trigger||document.activeElement;
      previousVehicle=api()?.getActive?.()||null;
      selectionMade=false;
      clearLegacyReturn();
      closeMobileMenu();
      renderCurrent();
      reset();
      host.hidden=false;
      document.body.classList.add('bm-vehicle-dialog-open');
      trigger?.setAttribute?.('aria-expanded','true');
      requestAnimationFrame(()=>qs(host,'.bm-vehicle-dialog__close')?.focus());
    };

    const close = ({restore=true}={}) => {
      if(host.hidden)return;
      host.hidden=true;
      document.body.classList.remove('bm-vehicle-dialog-open');
      clearLegacyReturn();
      opener?.setAttribute?.('aria-expanded','false');
      if(!selectionMade&&restore&&previousVehicle&&!api()?.getActive?.())api()?.setActive?.(previousVehicle);
      const focusTarget=opener;
      opener=null; previousVehicle=null; imageRequestId='';
      requestAnimationFrame(()=>focusTarget?.focus?.());
    };

    const selectorTrigger = '[data-bm-product-vehicle-selector], [data-bm-compat-action], [data-bm-vehicle-change-link], [data-bm-vehicle-stock-link], a[href*="#voertuigselector"]';

    document.addEventListener('pointerdown',(event)=>{
      const trigger=event.target.closest?.(selectorTrigger);
      if(trigger&&!host.contains(trigger))previousVehicle=api()?.getActive?.()||null;
    },true);

    document.addEventListener('click',(event)=>{
      const trigger=event.target.closest?.(selectorTrigger);
      if(!trigger||host.contains(trigger))return;
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    });

    host.addEventListener('click',async(event)=>{
      if(event.target.closest('[data-bm-vehicle-dialog-close]')){close();return;}
      if(event.target.closest('[data-bm-dialog-reset]')){reset();return;}
      if(event.target.closest('[data-bm-dialog-back]')){
        if(state.stage==='generation'){state.generation=null;setStage('model');if(status)status.textContent=`Kies je ${state.brand?.name||''}-model`;}
        else if(state.stage==='model'){state.model=null;state.generation=null;setStage('brand');if(status)status.textContent='Kies eerst je automerk';}
        return;
      }
      const choice=event.target.closest('.bm-choice[data-choice]');
      if(!choice||!host.contains(choice))return;
      const type=choice.dataset.choice;
      if(type==='brand'){
        state.brand=nodeData(choice);state.model=null;state.generation=null;setStage('model');
        if(status)status.textContent=`Modellen van ${state.brand.name} laden...`;
        const ok=await load(state.brand.url,'model');
        if(status)status.textContent=ok?`Kies je ${state.brand.name}-model`:`Geen modellen gevonden voor ${state.brand.name}`;
        return;
      }
      if(type==='model'){
        state.model=nodeData(choice);state.generation=null;setStage('generation');
        if(status)status.textContent=`Generaties van ${state.model.name} laden...`;
        const ok=await load(state.model.url,'generation');
        if(status)status.textContent=ok?'Kies je generatie':`Geen generaties gevonden voor ${state.model.name}`;
        return;
      }
      if(type==='generation'){
        const generation=nodeData(choice);
        const generationImage=choice.querySelector('img');
        const generationImageUrl=choice.dataset.image||generationImage?.currentSrc||generationImage?.getAttribute('src')||'';
        if(generationImageUrl){generation.image=generationImageUrl;writeImageCache(generation.id,generationImageUrl);}
        state.generation=generation;
        if(!state.brand||!state.model||!state.generation.id)return;
        const previous=previousVehicle||api()?.getActive?.();
        const providerIds=previous?.generation?.id===state.generation.id?(previous.providerIds||{}):{};
        selectionMade=Boolean(api()?.setActive?.({source:'internal-generation',brand:state.brand,model:state.model,generation:state.generation,providerIds,selectedAt:Date.now()}));
        if(status)status.textContent=selectionMade?'Auto geselecteerd':'Kon de auto niet opslaan';
        if(selectionMade){previousVehicle=null;setTimeout(()=>close({restore:false}),90);}
      }
    });

    search?.addEventListener('input',()=>{
      const query=search.value.trim().toLowerCase();
      qsa(qs(host,`[data-bm-dialog-options="${state.stage}"]`),'.bm-choice').forEach((choice)=>{
        choice.style.display=(choice.dataset.name||choice.textContent||'').toLowerCase().includes(query)?'':'none';
      });
    });

    document.addEventListener('keydown',(event)=>{
      if(host.hidden)return;
      if(event.key==='Escape'){event.preventDefault();close();return;}
      if(event.key!=='Tab'||!panel)return;
      const focusables=qsa(panel,'button:not([disabled]):not([hidden]),input:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])').filter((el)=>!el.hidden&&el.offsetParent!==null);
      if(!focusables.length)return;
      const first=focusables[0],last=focusables[focusables.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });

    window.BandenmeestersVehicleSelector={open,close};
    window.addEventListener('pageshow',()=>{if(!host.hidden)close({restore:false});});
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
